const baseHover = {
  '&:hover': {
    boxShadow: 'cardListHover',
    transition: 'box-shadow 0.3s ease, border-color 0.3s ease, transform 0.15s ease-out',
    textDecoration: 'none'
  },
  '&:active': {
    transform: 'scale(0.97)',
    boxShadow: 'none'
  }
};

const cardHover = {
  baseHover
};

export default cardHover;
